import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useDictionaries } from 'entities/creditForm';

export const AreaOfEmployment: FC<IFieldFactoryProps> = (props) => {
  const { areasOfEmployment } = useDictionaries(['areasOfEmployment']);
  const { type, ...other } = props;

  return (
    <ControlledCustomSelect
      {...other}
      name={type}
      options={areasOfEmployment}
      withCrossIcon={false}
    />
  );
};
